import PayBill from "./payBill"

/**
 * รายการชำระค่าโอนแผง — ใช้หน้า payBill เดิมทั้งก้อน
 * ต่างแค่ยิง GET /invoice/new/transfer-fee (subset ของ /invoice/new) และไม่มีปุ่มออกใบแจ้งหนี้
 */
export default function PayBillTransferFee() {
  return <PayBill transferFeeOnly />
}
